import { useMutation } from 'react-query';

import * as api from '../../../../../services/api';
import { UserInput } from '../../../../../types/registration/userInput';
import { queryClient, queryKeys } from '../../../../../utils/react-query';

interface BeregnEnergimerkeInput {
  registrationId?: string;
  userInput: UserInput;
}
export const useBeregnEnergimerkeSubmit = (registrationId: string) => {
  const { data, mutate, mutateAsync, isLoading } = useMutation(
    (input: BeregnEnergimerkeInput) => api.submitRegistration(input.registrationId, input.userInput),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.energyAnalysis, registrationId]);
      }
    }
  );

  return { submittedResponse: data, beregnEnergimerke: mutate, beregnEnergimerkeAsync: mutateAsync, beregnLoading: isLoading };
};
